import React from "react";
import { Card } from "react-bootstrap";

import Socials from "./Socials";

export default function Footer() {
  return (
    <Card className="text-center" id="Footer" style={{ border: "none" }}>
      <Card.Footer
        style={{
          backgroundColor: "var(--background-color)",
          padding: "5% 5% 1% 5%",
          color: "var(--text-color)",
        }}
      >
        <div>
          <Socials />
        </div>
        <br></br>
        <p>Made with ❤️ by Devika</p>
      </Card.Footer>
    </Card>
  );
}
